import React from 'react';
import { motion } from 'framer-motion';
const tomi = [{
  num: '1',
  title: 'Progettazione e Normativa (UDA)',
  tag: 'La burocrazia finalmente dalla tua parte',
  desc: 'Programmazione annuale, modelli UDA pronti, gestione delle 33 ore di Educazione Civica e struttura completa per il Biennio e Triennio. ✅ Apri, adatta e consegna al Dirigente con sicurezza.'
}, {
  num: '2',
  title: 'Fondamenti di Contabilità e IVA',
  tag: 'La partita doppia spiegata in modo che i tuoi studenti non la dimentichino più',
  desc: 'Dalla prima nota al registro IVA. Percorsi pronti con normativa fiscale 2025/2026 ed esercizi graduati per livello. ✅ Pronti per la fotocopia o lo schermo.'
}, {
  num: '3',
  title: "Il Bilancio d'Esercizio",
  tag: 'Stato Patrimoniale e Conto Economico spiegati alla Generazione Z',
  desc: 'Riclassificazione, analisi per indici e principi OIC con casi aziendali reali. ✅ 5 percorsi sul Bilancio pronti per domani mattina.'
}, {
  num: '4',
  title: 'Finanza Aziendale e Controllo di Gestione',
  tag: 'Costi, budget e Break Even spiegati con passione',
  desc: 'Analisi dei costi, Budget, Break Even Point e Direct Costing con casi aziendali reali. ✅ Finalmente coinvolge davvero i ragazzi.'
}, {
  num: '5',
  title: 'Diritto Commerciale e Mercati Finanziari',
  tag: 'Il quadro legale e finanziario senza stress',
  desc: "Società di capitali, contratti d'impresa, Borsa Valori e strumenti finanziari con percorsi tematici pronti. ✅ Percorsi pronti: le società, i contratti, i mercati, la finanza."
}, {
  num: '6',
  title: 'Il Successo alla Maturità',
  tag: "I tuoi studenti entrano all'esame preparati. Tu entri sereno.",
  desc: "Seconda Prova completa, simulazioni con casi aziendali reali e griglie ministeriali pronte all'uso. ✅ Compatibile con i quadri ministeriali 2025-2026."
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] relative border-t border-brand-orange/10" data-id="element-257">
      <div className="max-w-5xl mx-auto" data-id="element-258">
        <div className="text-center mb-8" data-id="element-259">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream mb-4" data-id="element-260">
            I 6 TOMI COMPLETI
          </motion.h2>
          <p className="text-xl text-brand-gold font-bold" data-id="element-261">
            Oltre 400 pagine di contenuto reale, pronto all'uso da oggi stesso.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-262">
          {tomi.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/10 p-6 rounded-2xl relative overflow-hidden group hover:border-brand-orange/40 transition-colors" data-id="element-263">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-white/5 group-hover:text-brand-orange/10 transition-colors" data-id="element-264">
                {tomo.num}
              </div>
              <div className="relative z-10" data-id="element-265">
                <div className="inline-block bg-brand-orange text-white text-xs font-black px-3 py-1 rounded-full mb-4 uppercase tracking-wider" data-id="element-266">
                  Tomo {tomo.num}
                </div>
                <h3 className="text-xl font-bold text-brand-cream mb-2 leading-tight" data-id="element-267">
                  {tomo.title}
                </h3>
                <p className="text-brand-gold/90 italic text-sm font-medium mb-3" data-id="element-268">
                  "{tomo.tag}"
                </p>
                <p className="text-gray-400 text-sm font-medium leading-relaxed" data-id="element-269">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}